export default __webpack_public_path__ + "static/media/image-7.48c61289.png";